import ActivityManager from "@/activity/ActivityManager";
import FormsLoader from "@/components/forms/FormsLoader";

const ActivityList = () => require("@/components/forms/ActivityList");
const ActivityEdit = () => require("@/components/forms/ActivityEdit");


/**
 @@action {
    name: "Show $$Form"
    patterns: "Show $$Form", "Open $$Form", "$$Form"
    icon: "$$Form.icon.list"
  }

 @@action{
    name: "Remove $$Form"
    patterns: "Remove $$Form", "Delete $$Form"
   icon: "$$Form.icon.list"
  }

 @@action{
    name: "Edit $$Form"
    patterns: "Edit $$Form", "Change $$Form", "Modify $$Form"
    icon: "$$Form.icon.list"
  }

 @@permissions: "$$Form.effectivePermissionList"

 @param {FormConfig} $$Form
 @returns {Promise<void>}
 */
export async function showList($$Form){
    await FormsLoader.runFormActivityListFromConfig($$Form)
}

/**
 @@action{
    name: "Edit $$FormEntity"
    patterns: "Edit $$FormEntity", "$$FormEntity"
    icon: "$$Form.icon.edit"
  }

 @@permissions: "$$Form.effectivePermissionRead"

 @param {FormConfig} $$Form
 @param {*} $$FormEntity
 @returns {Promise<void>}
 */
export async function editEntity($$FormEntity){
    await FormsLoader.runFormActivityEditFromConfig($$FormEntity.formConfig,
        {mode: "EDIT", formEntity: $$FormEntity.parameter, readOnlyInputs: true});
}

/**
 @@action {
    name: "Add $$Form"
    patterns: "Add $$Form", "New $$Form", "Create $$Form"
    icon: "$$Form.icon.add"
  }


 @@permissions: "$$Form.effectivePermissionWrite"

 @param {FormConfig} $$Form
 @returns {Promise<void>}
 */
export async function addEntityInForm($$Form){
    await FormsLoader.runFormActivityEditFromConfig($$Form, {mode: "NEW", readOnlyInputs: false});
}

/**
 @@action{
    name: "Remove $$FormEntity"
    patterns: "Remove $$FormEntity", "Delete $$FormEntity"
    icon: "$$Form.icon.remove"
  }

 @@permissions: "$$Form.effectivePermissionWrite"

 @param {FormConfig} $$Form
 @returns {Promise<void>}
 */
export async function deleteEntityInForm$$FormEntity($$FormEntity){
    await FormsLoader.runFormActivityListFromConfig($$FormEntity.formConfig,{mode: "DELETE", companyId: $$FormEntity.parameter.id})
}
